import React from 'react';
import {FaCheck, FaExclamationTriangle, FaTimes} from "react-icons/fa";

const NocStatusCellRenderer = ({value}) => {

    switch (value) {
        case "OFFLINE":
            return <FaTimes className="text-red-800"/>
        case "WARNING":
            return <FaExclamationTriangle className="text-yellow-500"/>
        case "ONLINE":
            return <FaCheck className="text-green-700"/>
        default: return <FaTimes className="text-red-800"/>
    }
};

export default NocStatusCellRenderer;